export default "__VITE_ASSET__CkcXCkOU__";